import { render, staticRenderFns } from "./LotteryRewardImage.vue?vue&type=template&id=2ffaee74"
import script from "./LotteryRewardImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryRewardImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LotteryRewardImage.vue?vue&type=style&index=0&id=2ffaee74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@2.2.1_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports